//
//
//
//
//
//
//
//
//
//
//

import CopyToClipboard from 'vue-copy-to-clipboard'
import { CopyIcon } from 'vue-feather-icons'

export default {
  name: 'CopyUrl',
  components: {
    CopyToClipboard,
    CopyIcon
  },
  props: {
    url: {
      type: String,
      required: true
    }
  },
  methods: {
    handleCopy () {
      this.$emit('copied')
    }
  }
}
